(() => {
  'use strict';
  const root = document.documentElement;
  const storageKey = 'carbon-color-scheme';
  const media = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  let preference = ['light', 'dark'].includes(root.dataset.colorPreference) ? root.dataset.colorPreference : null;
  const synchronise = () => {
    const dark = root.dataset.colorScheme === 'dark';
    document.querySelectorAll('[data-color-scheme-toggle]').forEach(button => {
      button.setAttribute('aria-checked', String(dark));
      button.title = dark ? button.dataset.lightTitle : button.dataset.darkTitle;
      const label = button.querySelector('[data-color-scheme-label]');
      if (label) label.textContent = dark ? button.dataset.darkLabel : button.dataset.lightLabel;
    });
  };
  const apply = choice => {
    preference = choice === 'dark' || choice === 'light' ? choice : null;
    const scheme = preference || (media?.matches ? 'dark' : 'light');
    root.dataset.colorPreference = preference || 'system';
    root.dataset.colorScheme = scheme;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = scheme === 'dark' ? '#0c121b' : '#f5f4f0';
    synchronise();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-color-scheme-toggle]');
    if (!button) return;
    const choice = root.dataset.colorScheme === 'dark' ? 'light' : 'dark';
    try { window.localStorage.setItem(storageKey, choice); } catch (error) {}
    apply(choice);
  });
  media?.addEventListener('change', () => { if (!preference) apply(null); });
  window.addEventListener('storage', event => {
    if (event.key === storageKey) apply(event.newValue);
    else if (event.key === null) apply(null);
  });
  window.addEventListener('pageshow', () => {
    try { apply(window.localStorage.getItem(storageKey)); } catch (error) { apply(preference); }
  });
  document.addEventListener('shopify:section:load', synchronise);
  apply(preference);
})();
